'use client'
import React, { useState } from 'react';
import Image, { StaticImageData } from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import * as styles from '@/style/landingPage/styles.css';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

interface CarouselItem {
  src: StaticImageData;
  alt: string;
}

interface ImageCarouselProps {
  items: CarouselItem[];
}

export default function ImageCarousel({ items }: ImageCarouselProps) {
  const [isInitialized, setIsInitialized] = useState(false);

  return (
    <div className={styles.carouselContainer} style={{ opacity: isInitialized ? 1 : 0, transition: 'opacity 0.3s ease' }}>
      <Swiper
        spaceBetween={5}
        slidesPerView={3}
        centeredSlides={true}
        initialSlide={1}
        onInit={() => setIsInitialized(true)}
        breakpoints={{
          340: {
            spaceBetween: 5
          },
          768: {
            spaceBetween: 10
          },
          1400: {
            spaceBetween: 20
          }
        }
        }
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            <div  >
               <Image 
                src={item.src}
                alt={item.alt}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
